import { render, staticRenderFns } from "./ModalPostcode.vue?vue&type=template&id=8ea74984&scoped=true"
import script from "./ModalPostcode.vue?vue&type=script&lang=js"
export * from "./ModalPostcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea74984",
  null
  
)

export default component.exports